// Add your custom JS here.
var nh =  0 // 0.13; // nav height
var body = document.querySelector('body');
var wrapper_navbar = document.querySelector('#wrapper-navbar');
var main_nav = document.querySelector('#main-nav');

wrapper_navbar.setAttribute('style', 'margin-top:-' + (window.innerHeight * nh) + 'px');
main_nav.setAttribute('style', "height:" + (window.innerHeight * 0.13) + "px"); // nh) + "px");// todo 0.1 icm 0.1 boven

//make entire logo clickable
var logo_wrapper = document.querySelector('.logo-wrapper');
logo_wrapper.addEventListener('click', function () {
    window.location.href = "/";
});
console.log(window.location.href);
//hero
// todo hardcode aanpassen link
if (window.location.href == "https://anthonyhealy.com//") {
    main_nav.style.opacity = 0;
    var hero = document.querySelector('.featured-hero');
    var title_wrapper = document.querySelectorAll('.title-wrapper');
    hero.setAttribute('style', "height:" + (window.innerHeight - (window.innerHeight * (nh))) + "px");
    for (var tw_i = 0; tw_i < title_wrapper.length; tw_i++) {
        title_wrapper[tw_i].setAttribute('style', "height:" + (window.innerHeight - (window.innerHeight * (nh))) + "px");
    }
    var hero_buttons = document.querySelector('#hero-buttons');
    var prev = document.querySelector('.carousel-control-prev-icon');
    var next = document.querySelector('.carousel-control-next-icon');
    var ih = 150; // icon height in pixels

    hero_buttons.setAttribute('style', "margin-top: -" + (0.5 * (window.innerHeight * (1 - nh)) + (0.5 * ih)) + "px");
    prev.setAttribute('style', "height:" + ih + "px");
    next.setAttribute('style', "height:" + ih + "px");

    var post_title = document.querySelectorAll('.post-title');
    var ll;
    for (var pt_i = 0; pt_i < post_title.length; pt_i++) {
        ll = getTextWidth(post_title[pt_i].innerHTML, getCanvasFontSize(post_title[pt_i]));
        if ( ll < 1100 ) {
            post_title[pt_i].style.fontSize = "3.3em"
        }
    }

    // navbar appear
    window.addEventListener('scroll', function () {
        main_nav.classList.add('trans1');
        main_nav.classList.add('opaque'); 
    });

    // Featured Hero buttons
    var prev_button = document.querySelector('.carousel-control-prev-icon');
    var next_button = document.querySelector('.carousel-control-next-icon');

    // hero-item-wrappers
    var items = document.querySelectorAll(".hero-item-wrapper")

    // length of carousel
    const count = items.length

    // Initialize Hero 
    // items[0].parentNode.insertBefore(items[count - 1], items[0])
    var items = document.querySelectorAll(".hero-item-wrapper")

    // add automatic scrolling
    var interval = setInterval( skip_hero_forward, 5000);

    // add eventlistener to buttons
    prev_button.addEventListener('click', function () {
        if ( prev_button.getAttribute('disabled') == 'disabled') {
            return;
        }
        prev_button.setAttribute('disabled', 'disabled');
        items[0].parentNode.insertBefore( items[count - 1], items[0] );
        items = document.querySelectorAll( ".hero-item-wrapper" )
        window.clearInterval(interval);
        setTimeout (function () {
            prev_button.setAttribute('disabled', '');        
        }, 300) 
    });

    next_button.addEventListener('click', function () {
        if ( next_button.getAttribute('disabled') == 'disabled') {
            return;
        }
        next_button.setAttribute('disabled', 'disabled');
        skip_hero_forward();
        window.clearInterval(interval);
        setTimeout (function () {
            next_button.setAttribute('disabled', '');        
        }, 300) 
    });
}
function getTextWidth(text, font) {
    var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    var context = canvas.getContext("2d");
    context.font = font;
    var metrics = context.measureText(text);
    return metrics.width;
};

function getCssStyle(element, prop) {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
}

function getCanvasFontSize(el = document.body) {
  const fontWeight = getCssStyle(el, 'font-weight') || 'normal';
  const fontSize = getCssStyle(el, 'font-size') || '16px';
  const fontFamily = getCssStyle(el, 'font-family') || 'Times New Roman';
  
  return `${fontWeight} ${fontSize} ${fontFamily}`;
}

// functions
function skip_hero_forward () {
    items[0].parentNode.appendChild( items[0] );
    items = document.querySelectorAll( ".hero-item-wrapper" )
}

// responsive nav menu
var nav_tog = document.querySelectorAll(".navbar-toggler");
var nav_drop = document.querySelector('.resp-nav-wrapper');

for (var nav_i = 0; nav_i < nav_tog.length; nav_i++) {
    nav_tog[nav_i].addEventListener('click', function () {
        if ( nav_drop.classList.contains('margin-left-0') ) {
            nav_drop.classList.remove('margin-left-0');
        } else {
            nav_drop.classList.add('margin-left-0');
        }
        
    });
}
// close button
var resp_close = document.querySelector('#resp-nav-close-button');
resp_close.addEventListener('click', function () {
    nav_drop.classList.remove('margin-left-0');
});